import axiosInstance from './axiosInstance';

// ========== AMS Audit History Types ==========

export interface AuditHistoryChange {
  field: string;
  from?: unknown;
  to?: unknown;
}

export interface AuditHistoryEvent {
  id: string;
  _id?: string;
  category: 'audit' | 'checkpoint' | 'asset' | 'equipment' | 'approval';
  eventType: string;
  actorId?: { id: string; name?: string; _id?: string } | string;
  actorName?: string;
  targetName?: string;
  summary: string;
  changes?: AuditHistoryChange[];
  remark?: string;
  metadata?: Record<string, unknown>;
  createdAt: string;
}

export interface AuditHistoryParams {
  category?: string;
  page?: number;
  limit?: number;
}

// ========== AMS Audit History API Service ==========

export const amsAuditHistoryService = {
  // Get paginated history events for an AMS project audit, optionally filtered by category
  getAuditHistory: async (auditId: string, params: AuditHistoryParams = {}) => {
    const res = await axiosInstance.get(`/ams/ams-project-audits/${auditId}/history`, { params });
    return {
      data: (res.data?.data ?? []) as AuditHistoryEvent[],
      meta: res.data?.meta,
    };
  },
};

export default amsAuditHistoryService;
